import { render, staticRenderFns } from "./HomepageSettingsDialog.vue?vue&type=template&id=bfc30f4c"
import script from "./HomepageSettingsDialog.vue?vue&type=script&lang=js"
export * from "./HomepageSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./HomepageSettingsDialog.vue?vue&type=style&index=0&id=bfc30f4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports